import React, { useContext, useEffect, useState } from 'react';
import FormType from './Type/FormType';
import MainForm from './MainForm/MainForm';
import FormContext from '../../context/form-context';
import AccordionCustom from '../../components/Accordion/Accordion';
import TransactionDetails from './TransactionDetails/TransactionDetails';
// import OTPUpload from './OTPUpload/OTPUpload';
import Grid from '@mui/material/Unstable_Grid2';


const FormContainer = () => {
    const { appState  } = useContext(FormContext);
    const {form,type} = appState.formType
    const {mode} = appState.formInfo
    const [isSelect, setIsSelect] = useState(false)

    useEffect(  () => {
        setIsSelect(false)
        //pause for 1 seconds
        // purpose: to refresh the state and to load the mainfields
        setTimeout(() => {
            if (form && type) {
                setIsSelect(true)
            }
        }, 1000);
     }, [form , type , mode])

    return(
        <>
            <FormType /> {/* this component is hidden, the selection of form and type will be done thru the RealStar CRM */}
            <TransactionDetails />
            {/* <AccordionCustom
                sectionName={""}
                expanded={true}
            >
                <Grid container spacing={2}>
                    <Grid xs={12} md={6}>
                        <FormType />
                    </Grid>
                    <Grid xs={12} md={6}>
                        {isSelect && <OTPUpload />}
                    </Grid>
                </Grid>
            </AccordionCustom> */}

            {isSelect && <MainForm />}
        </>
    )
}

export default FormContainer;